import { styled } from '@mui/system';
import { MainCard } from '@components/BaseStyles';

export const PaymentMethodMiniCard = styled(MainCard)({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: '8px 8px 8px 16px',
  maxWidth: '800px',
  width: '100%',
});

export const PaymentMethodMainCard = styled(MainCard)({
  display: 'flex',
  flexDirection: 'column',
});
